import styled from '@emotion/styled';
import { IUrlLinkItem, Responsive, ITheme, Css, ContentWrap } from '@/ui';
import { usePathname } from 'next/navigation';
import { getLinkPropsForUrl } from '../../../navigation/getLinkPropsForUrl';
import { RouterLink } from '../link/RouterLink';
import { Color } from '../../../styles/Color';
import { FONT_FAMILY_AVENIR_NEXT } from '../../../styles/Font';
import FooterSocialsSection from './FooterSocialsSection';
import { IFooterSocialLinksProps } from './FooterSocialLinks';
import { PageRoutes } from '../../../features/app/pages/domain/constants/PageRoutes';

const FULL_YEAR = new Date().getFullYear();

export interface IFooterFinePrintProps {
	links: IUrlLinkItem[];
	socialLinks: IFooterSocialLinksProps;
	oxdThemed: boolean;
}

export function FooterFinePrint({ links, socialLinks }: IFooterFinePrintProps) {
	const isMobileXL = Responsive.useMatchesBreakpoint('mobileXL');
	const pathname = usePathname();
	const oxdThemed = pathname === `${PageRoutes.OxdAirport}/`;

	return (
		<FooterFinePrintWrap oxdThemed={oxdThemed}>
			<StyledContentWrap>
				<strong>{`\u00A9 ${FULL_YEAR} CVG Airport`}</strong>
				<FooterFinePrintLinks>
					{links?.map((link) => (
						<RouterLink key={link.key} {...getLinkPropsForUrl(link.url)}>
							{link.title}
						</RouterLink>
					))}
				</FooterFinePrintLinks>
				{isMobileXL && <FooterSocialsSection socialLinks={socialLinks} />}
			</StyledContentWrap>
		</FooterFinePrintWrap>
	);
}

const FooterFinePrintWrap = styled.div<{ oxdThemed: boolean }, ITheme>`
	margin-top: ${Css.pxToRemFromTheme(40)};
	background-color: ${({ oxdThemed }) =>
		oxdThemed ? `${Color.OxdBackground}` : `${Color.PrimaryBlue97}`};
	padding: ${Css.pxToRemFromTheme(24)} 0;

	strong {
		font-family: ${FONT_FAMILY_AVENIR_NEXT};

		@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
			margin-top: ${Css.pxToRemFromTheme(32)};
		}
	}
`;

const StyledContentWrap = styled(ContentWrap)`
	display: flex;
	justify-content: space-between;

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		flex-direction: column-reverse;
	}
`;

const FooterFinePrintLinks = styled.div<{}, ITheme>`
	display: flex;
	gap: ${Css.pxToRemFromTheme(24)};

	a {
		text-decoration: none;
		color: ${Color.OnBackgroundText};
		font-weight: 400;

		&:hover {
			text-decoration: underline;
		}
	}

	@media (${Responsive.getMediaQueryForBreakpoint('mobileXL')}) {
		display: grid;
		grid-template-columns: repeat(2, 1fr);
		gap: ${Css.pxToRemFromTheme(24)};
	}
`;
